import { type SVGProps } from 'react';

import { colors } from '@/themesConfig/colors';

export const Check = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={colors.green}
      {...props}
    >
      <path d="M20.5068 5.44711C20.8121 5.727 20.8327 6.20143 20.5528 6.50677L9.55283 18.5068C9.41461 18.6576 9.22078 18.7454 9.01626 18.7498C8.81175 18.7542 8.61429 18.675 8.46964 18.5303L3.46964 13.5303C3.17675 13.2374 3.17675 12.7625 3.46964 12.4696C3.76253 12.1768 4.23741 12.1768 4.5303 12.4696L8.97641 16.9158L19.4471 5.49318C19.727 5.18784 20.2014 5.16721 20.5068 5.44711Z" />
    </svg>
  );
};
